import { render, staticRenderFns } from "./TrainingRegistration.vue?vue&type=template&id=e4253f0a&scoped=true&"
import script from "./TrainingRegistration.vue?vue&type=script&lang=js&"
export * from "./TrainingRegistration.vue?vue&type=script&lang=js&"
import style0 from "./TrainingRegistration.vue?vue&type=style&index=0&id=e4253f0a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4253f0a",
  null
  
)

export default component.exports